import React, { useEffect, useReducer, useState } from "react";
import "./DashboardUsePaymentPage.css";
import { Button, Divider, Group } from "@mantine/core";
import DetailUser from "../component/DetailUser";
import { IconPrinter, IconQrcode } from "@tabler/icons-react";
import { url } from "../../settings/linkUrl";
import AppModelQrCode from "../../(dialogs)/AppModelQrCode";

interface RowMoney {
  success: string;
  stdid: string;
  creck: string;
  payment_ref1: string;
  payment_ref2: string;
  payment_money: string;
  barcode: string;
  barcodeP: string;
  payment_timeout: string;
}

interface RowDataUser {
  id: string;
  url: string;
  faculty: string;
  programe: string;
  short_name: string;
  name: string;
  role: string;
  number_true: string;
  creck: string;
  vut: string;
  type_std_name: string;
}

export default function DashboardUsePaymentPage() {
  const [dataUser, SetdataUser] = useState<RowDataUser>();
  const [dataMoney, SetdataMoney] = useState<RowMoney>();

  const initialState = {
    loading: "",
    error: "",
    data: [],
  };

  function apiReducer(state: any, action: any) {
    switch (action.type) {
      case "DATA_FETCH_START":
        return { ...state, loading: "yes" };
      case "DATA_FETCH_SUCCESS":
        return { ...state, loading: "", data: action.payload };
      case "DATA_FETCH_FAILURE":
        return { ...state, loading: "", error: action.payload };
      default:
        return state;
    }
  }

  const [data, dispatch] = useReducer(apiReducer, initialState);

  const LoadPage = () => {
    let rr: any = localStorage.getItem("dataUser");
    SetdataUser(JSON.parse(rr));

    dispatch({ type: "DATA_FETCH_START" });
    const token = localStorage.getItem("token");
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    fetch(`${url}register/checkregister_money`, requestOptions)
      .then((respone) => {
        if (!respone.ok) throw Error(respone.statusText);
        return respone.json();
      })
      .then((json) => {
        dispatch({ type: "DATA_FETCH_SUCCESS", payload: json });
        SetdataMoney(json.data);
      })
      .catch((error) => {
        dispatch({ type: "DATA_FETCH_FAILURE", payload: error.message });
      });
  };

  useEffect(() => {
    LoadPage();
  }, []);

  return (
    <div className="DashboardSelectRegisterPage">
      <section>
        <DetailUser />
      </section>
      <Divider my="xs" size="md" color="blue" />
      <Group justify="center" mt="md">
        <AppModelQrCode
          payment_ref1={dataMoney?.payment_ref1}
          payment_ref2={dataMoney?.payment_ref2}
          payment_money={dataMoney?.payment_money}
          barcode={dataMoney?.barcode}
          barcodeP={dataMoney?.barcodeP}
          payment_timeout={dataMoney?.payment_timeout}
        />
      </Group>
    </div>
  );
}
